/**
 * Checks if the given date is today.
 *
 * To keep the function performant there is no type checking like 'date instanceof Date' or 'moment(date).isValid()'.
 * If you aren't sure about the arguments you pass to this function please validate them beforehand.
 *
 * @param {Date} date - The date object to validate.
 * @returns {boolean} Whether the provided date is today.
 */
export function isDateToday(date) {
    const now = new Date()

    return (
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate()
    )
}
